import '@styles/main.scss';

import {App} from '@main/app';

window.app = new App();
window.app.run();

import '@main/components/mobile-menu';
import '@main/components/base-slider';
import '@main/components/modal/open-modal';
import '@main/components/nominations';
import '@main/components/form/';
import '@main/components/section-observer';
import '@main/components/cookie';
